import { render, staticRenderFns } from "./ShopsTraffic.vue?vue&type=template&id=5578cb5a&scoped=true&"
import script from "./ShopsTraffic.vue?vue&type=script&lang=js&"
export * from "./ShopsTraffic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5578cb5a",
  null
  
)

export default component.exports